/*
 * logger.js - front end logging module
 *
 * Built on js-logger (https://github.com/jonnyreeves/js-logger)
 *
 */
import JSLogger from 'js-logger';
import $ from 'qwery';


function setup () {

    const whitelist = [
        'SecurityError (DOM Exception 18)'
    ];

    const isInWhitelist = message => whitelist.some(s => message.toLowerCase().indexOf(s.toLowerCase()) !== -1);
    const isScriptError = message => message.toLowerCase().indexOf('script error') > -1;

    // Global registration of the error handler
    window.onerror = function (message, url, lineNo, columnNo, error) {

        if (isInWhitelist(message)) return false;

        if (isScriptError(message)) {
            logger.error(message);
        } else if (typeof message === 'object') {
            logger.error(JSON.stringify(error), `${url} Line: ${lineNo}, Column: ${columnNo}`);
        } else {
            logger.error(message, `${url} Line: ${lineNo}, Column: ${columnNo}`);
        }

        return false;
    };

}

//Production Log Handler posts json log messages to the server.
//The endpoints used are '/Logging/[LOG LEVEL]'
const productionLogHandler = (messages, context) => {

    let errorStack = null;
    const level = context.level.name.toLowerCase();

    const messageArray = Object.keys(messages)
        .map(key => {
            const mess = messages[key];
            if (mess instanceof TypeError) {
                errorStack = mess.stack;
                return mess.message;
            }
            return mess.toString();
        });

    messageArray.unshift(context.name); //Adds the logger name as the first message

    if (window.dataLayer) {
        const experiments = [];
        window.dataLayer.forEach(value => {
            if (value.event && value.event === 'trackExperiment') {
                experiments.push(value);
            }
        });
        if (experiments.length > 0) {
            messageArray.push(`Experiments: ${JSON.stringify(experiments)}`);
        }
    }

    if (navigator) messageArray.push(`useragent:${navigator.userAgent}`);

    const postData = { messages: messageArray };

    if (level === 'error') {
        postData.url = window.location.href;
        if (errorStack) {
            postData.stack = errorStack;
        }
    }

    fetch(`/Logging/${level}`,
        {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(postData)
        });
};

//Debug Log Handler pushes all log messages to the console
const debugLogHandler = JSLogger.createDefaultHandler({
    formatter: function (messages, context) {
        messages.unshift(`[${context.name} ${context.level.name}]`); //Adds the logger name and level as the first message
    }
});

JSLogger.useDefaults({
    defaultLevel: JSLogger.ERROR
});
JSLogger.setHandler(productionLogHandler);

//export to the global scope with 'let' to create a singleton
export const logger = JSLogger.get('Default');

export const experimentLogger = JSLogger.get('Experiment');
//Allows the experiment logger to switched to INFO by searching for an element with
// the attribute 'data-experiment-logging-on' on an element in the DOM
if ($('[data-experiment-logging-on]').length) {
    experimentLogger.setLevel(JSLogger.INFO);
}

//Null logger to allow logs to be turned off and let log statements remain in code
export const nullLogger = JSLogger.get('Null');
nullLogger.setLevel(JSLogger.OFF);

//Allow loggers to be used globally
window.logger = logger;
window.experimentLogger = experimentLogger;

//Allow loggers to be set to DEBUG mode from the console
window.beginDebugLog = function () {
    JSLogger.setHandler(debugLogHandler);
    logger.setLevel(JSLogger.DEBUG);
    experimentLogger.setLevel(JSLogger.DEBUG);
};

//Allow log handler to be injected for testing
export function setLogHandler (handler) {
    JSLogger.setHandler(handler);
}

setup();
